import './App.css';
import Navbar from './Components/Navbar';
import Latestupdates from './Components/Latestupdates';
import Aboutus from './Components/Aboutus';
import Blogs from './Components/Blogs';
import Contactus from './Components/Contactus';
import Footer from './Components/Footer';
import {BrowserRouter as Router, Routes,Route} from 'react-router-dom';

function App() {
  return (
    <div className="App">
     <Router>
      <Navbar/>
     <Routes>
        <Route path="/"/>
        <Route path="/blogs" element={ <Blogs/> } />
        <Route path="/aboutus" element={ <Aboutus/> } />
        </Routes>
      </Router>
     <Latestupdates/>
     <Blogs/>
     <Aboutus/>
     <Contactus/>
     <Footer/> 
    </div>
  );
}

export default App;
